import React from "react"
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { AppProvider } from './context/store'
import getLocalStorage from './utils/getLocalStorage'

import 'semantic-ui-css/semantic.min.css'

import Login from './containers/Login/Login'
import Dashboard from './containers/Overview/Dashboard'

const PrivateRoute = ({component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            getLocalStorage('token') ?
                <Component {...props} />
            : <Redirect to="/" />
        )} />
    );
};


function App() {
    return (
        <div className="App">
            <AppProvider>
            <BrowserRouter>
                <Switch>
                    <Route path="/" component={Login} exact />
                    <PrivateRoute path="/overview" component={Dashboard} />
                </Switch>
            </BrowserRouter>
            </AppProvider>
        </div>
    );
}

export default App;
